import React from 'react'
import { View, TextInput, StyleSheet } from 'react-native'
import { useAppTheme } from '#app/theme'

interface SearchInputProps {
  value: string
  onChangeText: (text: string) => void
  placeholder?: string
}

export function SearchInput({ value, onChangeText, placeholder = 'Search...' }: SearchInputProps) {
  const theme = useAppTheme()

  return (
    <View style={styles.container}>
      <TextInput
        style={[
          styles.input,
          {
            color: theme.textColor,
            backgroundColor: theme.formForm.search,
            borderColor: theme.border.borderColor,
          },
        ]}
        value={value}
        onChangeText={onChangeText}
        placeholder={placeholder}
        placeholderTextColor={theme.formForm.placeholderTextColor}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    padding: 12,
  },
  input: {
    height: 40,
    borderWidth: 1,
    borderRadius: 8,
    paddingHorizontal: 12,
  },
}) 